import ActionType from '../../actions/aboutJingWei/ActionType';

const initialState={
    jw_list_data:[],
    jw_detail_data:null,
    jw_zxzx_data:[],
}

const jwListReducer=(state=initialState,action={})=>{
    switch(action.type){
        case ActionType.FETCH_JW_LIST:
            return Object.assign({},state,{
                jw_list_data:action.data,
            });
        case ActionType.FETCH_JW_DEATIL:
            return Object.assign({},state,{
                jw_detail_data:action.data,
            })
        case ActionType.FETCH_PARTNER_NEWS_DETAIL:
            return Object.assign({},state,{
                //当执行这个action时，获取的就是合作伙伴新闻数据，仍给jw_detail_data
                jw_detail_data:action.data, 
            })
        case ActionType.FETCH_JW_ZXZX:
            return Object.assign({},state,{
                jw_zxzx_data:action.data,
            })
        default:
            return state;
    }
}

export default jwListReducer;